import cn from 'utils/cn'
import { LINK_HC_LINK_HR_SYSTEM } from 'constants/Links'
import Button from 'core/components/buttons/Button'
import Switch from 'core/components/inputs/Switch'
import { useSettings } from 'core/hooks/settings/useSettings'
import { FundingModalFormValues } from 'core/widgets/funding-modal/FundingModal'
import LinkButton from 'core/components/buttons/LinkButton'
import { useCallback, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

const FundingAutoPay = () => {
  const { set } = useSettings()
  const { watch, setValue } = useFormContext<FundingModalFormValues>()
  const [amountType, fundingMethod, autoPay, accountId] = watch([
    'amountType',
    'funding_method',
    'auto_pay',
    'account_id'
  ])
  const isOtherAmount = useMemo(
    () => amountType === 'other-amount',
    [amountType]
  )

  const showAutoPayNote = useMemo(
    () => autoPay && isOtherAmount === false,
    [autoPay, isOtherAmount]
  )

  const disabled = useMemo(() => {
    if (fundingMethod === undefined) return true
    if (fundingMethod === 'ach-debit') return !accountId
    return false
  }, [fundingMethod, accountId])

  const onClick = useCallback(() => {
    if (amountType === 'other-amount') {
      set('fundingModal', {
        show: false,
        showSuccessModal: true
      })
      return
    }
    if (fundingMethod === 'ach-debit') {
      set('fundingModal', {
        show: false,
        showSuccessModal: true
      })
      return
    }
  }, [amountType, set, fundingMethod])

  return (
    <div className="bg-dark-8 p-8 relative -left-8 top-8 w-[calc(100%+4rem)]">
      {isOtherAmount === false && (
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-2">
            <Switch
              value={autoPay}
              onChange={(value) => setValue('auto_pay', value)}
            />
            <span className="text-sm text-dark">
              Auto-pay the selected pay periods
            </span>
          </div>
          <LinkButton text="Learn more" url={LINK_HC_LINK_HR_SYSTEM} />
        </div>
      )}
      <div className={cn(showAutoPayNote ? 'mb-4' : '')}>
        <Button
          variant="primary"
          className="w-full"
          onClick={onClick}
          disabled={disabled}
        >
          {fundingMethod === 'ach-debit'
            ? 'Generate funding request'
            : 'Initiate funding'}
        </Button>
      </div>
      {showAutoPayNote && (
        <div className="text-sm text-dark text-center">
          Auto-pay will immediately disburse funds to your team for reports in
          the selected pay periods, unless canceled.
        </div>
      )}
    </div>
  )
}

export default FundingAutoPay
